import React from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import { connect } from 'react-redux';
import { clearFeedback } from '../../store/modules/feedback';

const mapActionCreators = {
  clearFeedback,
};

const mapStateToProps = state => ({
  feedback: state.feedback,
});

const style = {
  NotificationItem: {
    // Override the notification item
    DefaultStyle: {
      // Applied to every notification, regardless of the notification level
      backgroundColor: '#fff',
      padding: 20,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: '1px solid #e5e5e5',
      borderRadius: 4,
    },

    success: {
      // Applied only to the success notification item
      backgroundColor: '#fff',
      // borderColor: '#4a90e2'
    },
    error: {
      borderColor: '#e93d19',
    },
  },
  Dismiss: {
    DefaultStyle: {
      width: 24,
      height: 24,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // opacity: 0.4,
      position: 'relative',
      top: 'auto',
      right: 'auto',
      color: '#4a4a4a',
      backgroundColor: '#fff',
    },
    // success: {
    //   color: '#4a4a4a',
    // }
    // error: {
    //   color: '#fff',
    //   backgroundColor: '#b22b10'
    // }
  },
};

export class FeedbackProvider extends React.Component {
  constructor(props) {
    super(props);
    this._notificationSystem = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps);

    nextProps.feedback.map(feedback => {
      if (feedback.level === 'error') {
        this._notificationSystem.addNotification({
          message: feedback.message,
          level: feedback.level,
          position: 'bl',
          autoDismiss: 0,
        });
      } else {
        this._notificationSystem.addNotification({
          message: feedback.message,
          level: feedback.level,
          position: 'bl',
          autoDismiss: 5,
        });
      }
    });

    if (nextProps.feedback.length) {
      this.props.clearFeedback();
    }
  }

  render() {
    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
      </div>
    );
  }
}

FeedbackProvider.propTypes = {
  feedback: PropTypes.array.isRequired, // eslint-disable-line react/no-unused-prop-types
  clearFeedback: PropTypes.func.isRequired,
};

FeedbackProvider.defaultProps = {
  feedback: [],
};

export default connect(mapStateToProps, mapActionCreators)(FeedbackProvider);



// WEBPACK FOOTER //
// ./src/components/FeedbackProvider/FeedbackProvider.js